import React, { useEffect, useState } from "react";
import { useSetting } from "store/settings";
import { handleSuccessMessages } from "store/auth";
import { Field, Form, Formik } from "formik";
import { Loading, TextField, MultiSelect, Select,CheckBox } from "components/form";
import Modal from "components/Modal";
import { useCore } from "store/core";
import { generate_uuid } from "lib/helpers";
import {  useParams } from "react-router-dom";
import { required, validationWrapper,number } from "lib/formValidations";
const FestivalWidgets = (props) => {

  const key = "widgets";
  const { id } = useParams();
  const [showAddWidget, setShowAddWidget] = useState(false);
  const [showEditWidget, setShowEditWidget] = useState(false);
  const [showDeleteWidget, setShowDeleteWidget] = useState(false);
  const [item, setItem] = useState("");
  const [festival, setFestival] = useState(null);
  const [loading, setLoading] = useState(false);
  const core = useCore();

  useEffect(async() => {
    setLoading(true);
    core.dispatch(core.getGenres());
    core.dispatch(core.getProductCategories());
    const data=await core.dispatch(core.getFestival(id));
    setFestival(data);
    setLoading(false);
    
  }, []);

  if (loading) {
     return ( <div className="content" style={{ marginBottom: 80 }}>
     
     <div className="grid grid-cols-12 gap-6 mt-5"><div className="box p-5 flex justify-center w-100">
        <Loading/>
     </div></div></div>)
  }

  return (
    <>
      <AddWidget
        show={showAddWidget}
        close={(e,data=null) => {if(data&&data!==null){console.log(data);setFestival(data)} setShowAddWidget(false)}}
        title="افزودن ویجت "
        festival={festival}
        id={id}       
      />
      <EditWidget
        item={item}
        show={showEditWidget}
        close={(e,data=null) => {if(data&&data!==null){setFestival(data)} setShowEditWidget(false)}}
        title="ویرایش ویجت "
          festival={festival}
          id={id}
      />
      <DeleteWidget
        item={item}
        show={showDeleteWidget}
        close={() => setShowDeleteWidget(false)}
        title="حذف ویجت "
        submite={async () => {
          const data=await core.dispatch(
            core.manageFestivalWidgets(id,{
              widgets: festival.widgets&&[...festival.widgets.filter((i) => i.uuid !== item.uuid)],
              
            })
          );
          if(data)
          {
            setFestival(data);
          }
          setShowDeleteWidget(false);
        }}
      />
 <div className="content" style={{ marginBottom: 80 }}>
     
        <div className="grid grid-cols-12 gap-6 mt-5">
          
      <div className="box intro-y col-span-12 overflow-auto lg:overflow-visible">
        <div className="flex justify-between py-2 px-3">
          <h3> لیست ویجت های{festival&&" "+festival.title}</h3>
          <button
            onClick={() => setShowAddWidget(true)}
            className="btn btn-sm btn-primary"
          >
            افزودن ویجت 
          </button>
        </div>
        <hr />
        {festival&&festival.widgets && festival.widgets.length < 1 && (
          <h3 className="p-5 text-center">چیزی برای نمایش وجود ندارد!</h3>
        )}
        {festival&&festival.widgets && festival.widgets.length > 0 && (
          <table className="table table-report -mt-2">
            <thead>
              <tr>
                <th className="whitespace-nowrap text-center">اولویت</th>
                <th className="whitespace-nowrap text-center">عنوان</th>
                <th className="whitespace-nowrap text-center">عنوان انگلیسی</th>
                <th className="whitespace-nowrap text-center">دسته بندی ها</th>
                <th className="whitespace-nowrap text-center">ژانر ها</th>
                <th className="whitespace-nowrap text-center">وضعیت</th>
                <th className="whitespace-nowrap text-center">عملیات</th>
              </tr>
            </thead>
            <tbody className="text-center">
              {festival&&festival.widgets &&
                festival.widgets.map((item) => (
                  <tr>
                    <td>{item.order}</td>
                    <td>{item.title}</td>
                    <td>{item.en_title}</td>
                    <td className="text-xs">
                      {item.categories &&
                        core.productCategories &&
                        core.productCategories
                          .filter((i) => item.categories.includes(i.value))
                          .map((gi) => gi.label + ", ")}
                    </td>
                    <td className="text-xs">
                      {item.genres &&
                        core.genres &&
                        core.genres
                          .filter((i) => item.genres.includes(i.value))
                          .map((gi) => gi.label + ", ")}
                    </td>
                    <td>{item.status?"فعال":"غیرفعال"}</td>
                    <td className="w-56">
                      <button
                        className="btn btn-sm btn-info mx-1"
                        onClick={() => {
                          setItem(item);
                          setShowEditWidget(true);
                        }}
                      >
                        ویرایش
                      </button>
                      <button
                        className="btn btn-sm btn-danger mx-1"
                        onClick={() => {
                          setItem(item);
                          setShowDeleteWidget(true);
                        }}
                      >
                        حذف
                      </button>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        )}
      </div>
      </div>
      </div>
    </>
  );
};

export default FestivalWidgets;

export function AddWidget(props) {
  const {id,festival}=props
  const core = useCore();
  
  
  return (
    <Modal show={props.show} handleClose={props.close} title={props.title}>
      <Formik
        initialValues={{ uuid: generate_uuid() }}
        onSubmit={async (values, { setSubmitting }) => {
          const data=await core.dispatch(
            core.manageFestivalWidgets(id,{ widgets: festival.widgets?[...festival.widgets, values]:[values] }, () => {
              handleSuccessMessages("ویرایش اطلاعات انجام شد");
              
            })
          );
          if(data)
          {props.close(null,data)}
          setSubmitting(false);
        }}
        enableReinitialize
      >
        {({ isSubmitting, dirty, values }) => (
          <Form>
            <div className="box rounded p-3">
              
              <hr className="my-2" />
              <div className="">
                <div className="intro-x grid grid-cols-2 gap-4">
                  <Field
                    placeholder="انتخاب نوع"
                    label="انتخاب نوع :"
                    name="type"
                    component={Select}
                    options={[
                      { value: "PRODUCT_LIST", label: "محصولات" },
                      { value: "FEATURED_LIST", label: "محصولات ویژه" },
                      { value: "NEW_PRODUCT_LIST", label: "محصولات جدید" },
                      { value: "GENRE_LIST", label: "ژانرها" },
                      { value: "PRODUCT", label: "تک محصول" },
                    ]}
                  />
                  {values.type == "PRODUCT" && (
                    <Field
                      placeholder="شناسه محصول"
                      label="شناسه محصول :"
                      name="product_id"
                      type="number"
                      component={TextField}
                    />
                  )}
                  {(values.type == "NEW_PRODUCT_LIST" ||
                    values.type == "FEATURED_LIST") && (
                    <Field
                      placeholder="تعداد محصول"
                      label="تعداد محصول :"
                      name="count"
                      component={TextField}
                    />
                  )}
                  <Field
                    placeholder="عنوان"
                    label="عنوان :"
                    name="title"
                    component={TextField}
                  />
                  <Field
                    placeholder="عنوان انگلیسی"
                    label="عنوان انگلیسی :"
                    name="en_title"
                    component={TextField}
                  />
                  <Field
                    placeholder="اولویت"
                    label="اولویت :"
                    name="order"
                    component={TextField}
                    type="number"
                  />
                   <Field
                    placeholder="فعال"
                    label="فعال "
                    name="status"
                    component={CheckBox}
                    
                  />
                   <Field
                    placeholder="نمایش تصادفی"
                    label="نمایش تصادفی "
                    name="random_sort"
                    component={CheckBox}
                    
                  />
                  {values.type == "PRODUCT_LIST" && (
                    <>
                      <div>
                        <Field
                          placeholder="انتخاب دسته بندی"
                          label="انتخاب دسته بندی :"
                          name="categories"
                          component={MultiSelect}
                          valueOnly={true}
                          options={core.productCategories || {}}
                        />
                      </div>
                      <div>
                        <Field
                          placeholder="انتخاب ژانر"
                          label="انتخاب ژانر :"
                          name="genres"
                          valueOnly={true}
                          component={MultiSelect}
                          options={core.genres || {}}
                        />
                      </div>
                    </>
                  )}
                  <div></div>
                  <button
                    className="mt-4 btn btn-primary w-20"
                    type="submit"
                    disabled={!!(isSubmitting || !dirty)}
                  >
                    {isSubmitting ? <Loading /> : "ذخیره"}
                  </button>
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </Modal>
  );
}

export function EditWidget(props) {
  const {id,festival}=props
  const core = useCore();
  
 
  return (
    <Modal show={props.show} handleClose={props.close} title={props.title}>
      <Formik
        initialValues={props.item}
        onSubmit={async (values, { setSubmitting }) => {
          const data=await core.dispatch(
            core.manageFestivalWidgets(id,
              {
                widgets: festival.widgets&&[
                  ...festival.widgets.filter((i) => i.uuid !== props.item.uuid),
                  values,
                ],
                
              },
              () => {
                handleSuccessMessages("ویرایش اطلاعات انجام شد");
               
              }
            )
          );
          if(data)
          {props.close(null,data)}
          setSubmitting(false);
        }}
        enableReinitialize
      >
        {({ isSubmitting, dirty, values }) => (
          <Form>
            <div className="box rounded p-3">
              
              <hr className="my-2" />
              <div className="">
                <div className="intro-x grid grid-cols-2 gap-4">
                  <Field
                    placeholder="انتخاب نوع"
                    label="انتخاب نوع :"
                    name="type"
                    component={Select}
                    options={[
                      { value: "PRODUCT_LIST", label: "محصولات" },
                      { value: "FEATURED_LIST", label: "محصولات ویژه" },
                      { value: "NEW_PRODUCT_LIST", label: "محصولات جدید" },
                      { value: "GENRE_LIST", label: "ژانرها" },
                      { value: "PRODUCT", label: "تک محصول" },
                    ]}
                  />
                  {values.type == "PRODUCT" && (
                    <Field
                      placeholder="شناسه محصول"
                      label="شناسه محصول :"
                      name="product_id"
                      type="number"
                      component={TextField}
                      validate={(value) => validationWrapper(value, number)}
                    />
                  )}
                  {(values.type == "NEW_PRODUCT_LIST" ||
                    values.type == "FEATURED_LIST") && (
                    <Field
                      placeholder="تعداد محصول"
                      label="تعداد محصول :"
                      name="count"
                      component={TextField}
                    />
                  )}
                  <Field
                    placeholder="عنوان"
                    label="عنوان :"
                    name="title"
                    component={TextField}
                  />
                  <Field
                    placeholder="عنوان انگلیسی"
                    label="عنوان انگلیسی :"
                    name="en_title"
                    component={TextField}
                  />
                  <Field
                    placeholder="اولویت"
                    label="اولویت :"
                    name="order"
                    component={TextField}
                    type="number"
                  />
                  <Field
                    placeholder="فعال"
                    label="فعال "
                    name="status"
                    component={CheckBox}
                    
                  />
                  <Field
                    placeholder="نمایش تصادفی"
                    label="نمایش تصادفی "
                    name="random_sort"
                    component={CheckBox}
                    
                  />
                  {values.type == "PRODUCT_LIST" && (
                    <>
                      <div>
                        <Field
                          placeholder="انتخاب دسته بندی"
                          label="انتخاب دسته بندی :"
                          name="categories"
                          component={MultiSelect}
                          valueOnly={true}
                          options={core.productCategories || {}}
                        />
                      </div>
                      <div>
                        <Field
                          placeholder="انتخاب ژانر"
                          label="انتخاب ژانر :"
                          name="genres"
                          component={MultiSelect}
                          valueOnly={true}
                          options={core.genres || {}}
                        />
                      </div>
                    </>
                  )}

                  <button
                    className="mt-4 btn btn-primary w-20"
                    type="submit"
                    disabled={!!(isSubmitting || !dirty)}
                  >
                    {isSubmitting ? <Loading /> : "ذخیره"}
                  </button>
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </Modal>
  );
}

export function DeleteWidget(props) {
  
  const core = useCore();
  
  
  return (
    <Modal show={props.show} handleClose={props.close} title={props.title}>
      <div className="modal-body gap-y-3">
        <h4>آیا از حذف این ویجت  مطمئن هستید؟</h4>
      </div>
      <div className="modal-footer flex justify-between">
        <button
          className="btn btn-danger w-20"
          type="button"
          onClick={props.submite}
        >
          حذف
        </button>
        <button
          type="button"
          onClick={props.close}
          className="btn btn-outline-secondary w-20 mr-1 text-white"
        >
          انصراف
        </button>
      </div>
    </Modal>
  );
}
